export const BANNER_DATA = 'BANNER_DATA'
export const BANNER_RESET = 'BANNER_RESET'
export const SCREEN_READER_DATA = 'SCREEN_READER_DATA'
export const SCREEN_READER_DATA_RESET = 'SCREEN_READER_DATA_RESET'
